
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export default function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    // Vérifier si l'utilisateur est déjà connecté
    const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
    
    const timer = setTimeout(() => {
      if (isAuthenticated) {
        navigate('/dashboard');
      } else {
        navigate('/login');
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
      <div className="text-center">
        <div className="mb-8">
          <div className="w-20 h-20 bg-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <i className="ri-building-2-fill text-white text-3xl"></i>
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-2">MAI MAB SERVICES</h1>
          <p className="text-xl text-gray-600">Système de Gestion Intégrée</p>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-8 max-w-md mx-auto">
          <div className="mb-6">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-loader-4-line text-blue-600 text-xl animate-spin"></i>
            </div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">Bienvenue</h2>
            <p className="text-gray-600">Chargement de votre espace de travail...</p>
          </div>

          <div className="space-y-3 text-left">
            <div className="flex items-center space-x-3 text-sm text-gray-600">
              <i className="ri-check-line text-green-500"></i>
              <span>Gestion des ventes et achats</span>
            </div>
            <div className="flex items-center space-x-3 text-sm text-gray-600">
              <i className="ri-check-line text-green-500"></i>
              <span>Suivi des stocks en temps réel</span>
            </div>
            <div className="flex items-center space-x-3 text-sm text-gray-600">
              <i className="ri-check-line text-green-500"></i>
              <span>Gestion financière intégrée</span>
            </div>
            <div className="flex items-center space-x-3 text-sm text-gray-600">
              <i className="ri-check-line text-green-500"></i>
              <span>Rapports et analyses</span>
            </div>
          </div>
        </div>

        <p className="mt-8 text-sm text-gray-500">
          © 2024 MAI MAB SERVICES - Tous droits réservés
        </p>
      </div>
    </div>
  );
}
